<template>
  <creneau
    :borneDebut="borneDebut"
    :creneau="creneau"
    :indisponibilite="indisponibilite"
    :inlineStyle="style"
    :disabled="disabled"
    :slot-height="slotHeight"
    :actions-seules="true"
  >
    <template v-slot:icon>
      <v-icon :color="color">mdi-chat-alert</v-icon>
    </template>
    <template v-slot:actionsOwner>
      <v-list-item-group>
        <v-list-item @click="sendAnnulerDelegation">
          <v-list-item-icon>
            <v-icon color="grey">mdi-history</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Annuler le temps de délégation</v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </template>
  </creneau>
</template>

<script>
import Creneau from './creneau'
import Color from 'color'
import { mapActions } from 'vuex'

export default {
  name: 'creneau-de-delegation',
  components: {
    Creneau,
  },
  data() {
    return {
      showAbsenceCreateDialog: false,
    }
  },
  props: {
    slotHeight: {
      type: Number,
      required: true,
    },
    borneDebut: {
      type: Object,
      required: true,
    },
    creneau: {
      type: Object,
      required: true,
    },
    indisponibilite: {
      type: Object,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    membre() {
      return this.creneau.membre
    },
    style() {
      return {
        borderStyle: 'solid',
        borderWidth: '3px',
        borderColor: this.color,
        background: this.colorLighter,
      }
    },
    color() {
      return this.membre.couleur
    },
    colorLighter() {
      return Color(this.membre.couleur).lightness(90).hex()
    },
  },
  methods: {
    ...mapActions({
      annulerCreneauDeDelegation: 'servicePlanning/annulerCreneauDeDelegation',
    }),
    sendAnnulerDelegation() {
      this.annulerCreneauDeDelegation(this.creneau)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
